"use client";
import SectionWrapper from "@cc/section-wrapper";
import { H3 } from "@theme/components/typography.fontvariant";
import ArrowBannerBackground, {
  ArrowBannerBackgroundProps,
} from "@cc/arrow-banner-background";
import { Stack, Typography } from "@mui/material";
import { PlayArrowRounded } from "@mui/icons-material";

export interface EducationProps {
  data: {
    title: string;
    bannerImages: ArrowBannerBackgroundProps["images"];
    educationData: string[];
  };
  navId?: string;
}

const Education = (props: EducationProps) => {
  const { data, navId } = props;
  const { title, bannerImages, educationData } = data;
  return (
    <SectionWrapper
      navId={navId || "Education"}
      color={"secondary.main"}
      SectionProps={{
        id: "education",
        sx: {
          background: (theme) => theme.palette.gradient.darkToLight,
        },
      }}
      SectionHeaderProps={{
        title,
        TitleTypographyProps: {
          fontSize: H3,
        },
      }}
    >
      <ArrowBannerBackground
        images={bannerImages}
        position={"relative"}
        height={{ xs: 254, md: 368, xl: 480 }}
        bgcolor={"secondary.500"}
        zIndex={"unset"}
        overflow={"hidden"}
        mb={{ xs: 5, md: 6 }}
      />
      <Stack direction={{ xs: "column", lg: "row" }} rowGap={4} columnGap={7}>
        {educationData.map((item, index) => {
          return (
            <>
              <Typography key={index} display={"flex"} columnGap={1}>
                <PlayArrowRounded
                  fontSize={"small"}
                  sx={{
                    ml: -1,
                  }}
                />
                {item}
              </Typography>
            </>
          );
        })}
      </Stack>
    </SectionWrapper>
  );
};

export default Education;
